var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClasses,attrs:{"type":"button","role":"switch","aria-checked":_vm.value.toString()},on:{"click":_vm.onClick}},[_c('span',{class:_vm.spanClasses,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }